export const templateCategoryKeys = {
  all: ["templateCategory"] as const,
  list: (filter?: { page: number; pageSize: number; searchTerm?: string }) =>
    filter
      ? ([
          ...templateCategoryKeys.all,
          "list",
          { page: filter.page, pageSize: filter.pageSize, searchTerm: filter.searchTerm },
        ] as const)
      : ([...templateCategoryKeys.all, "list"] as const),
}
